module.exports = __webpack_public_path__ + "img/icon-devices.356e430e.svg";